export default "__VITE_ASSET__acbd3e1b__"